import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { DebugColor } from "./DebugColor";
import { useShowDebugConfigurations } from "./DebugOptions";
import { DebugItemPopover } from "./DebugPopover";
import { DebugType } from "./DebugType";
export function CsCfgObjectStubDebug(props) {
    const showDebug = useShowDebugConfigurations();
    if (!showDebug) {
        return _jsx(Fragment, {});
    }
    const { substructure, chipSx } = props;
    return (_jsx(DebugItemPopover, { item: substructure, color: DebugColor.Substructure, type: DebugType.Configuration, title: substructure.id, chipSx: chipSx }));
}
//# sourceMappingURL=CsCfgObjectStubDebug.js.map